module.exports = __webpack_public_path__ + "static/media/kocka2METADATA.63abd6d2.png";